/**
 * Simple function which identifies the first press of "tab" which signals
 * that a keyboard user is active on the site. A class is applied to the body
 * of the site, which then allows us to apply the "outline" to links for accessibility
 * only when necessary.
 * 
 * @param e event passed from the listener
 */
function handleFirstTab(e) {
    if (e.keyCode === 9) { 
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
    }
}

window.addEventListener('keydown', handleFirstTab);

/**
 * Simple function which identifies the use of the mouse which signals
 * that a user is using the site normally. If the "user-is-tabbing" class is currently
 * assigned, it is removed, and the listener for a keyboard user is re-applied to the
 * tab event, so that the class can be re-added if the user begins re-using the keyboard
 * 
 * @param e event passed from the listener
 */
function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
  }
  
  window.addEventListener('keydown', handleFirstTab);